export default "__VITE_ASSET__C_e_NxTL__"